export const VARIABLE = '';

export const PhoneRegExp = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
export const ZipcodeRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const LastFourDigits = /^[0-9]{4}$/;
export const CompleteSSN = /^\d{3}-\d{2}-\d{4}$/;
export const EINRegExp = /^[1-9]\d?-\d{7}$/;
export const SSNRegExp =
  /^(?!0{3})(?!6{3})[0-8]\d{2}-(?!0{2})\d{2}-(?!0{4})\d{4}$/;
export const PasswordRegex =
  /^(?=.*\d)(?=.*[A-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?!.*[^a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(.{8,})$/;
export const BankAccountNumberRegex = /^[0-9]{7,14}$/;
export const RoutingNumberRegex = /(^(?:[0][1-9]|[13][0-2]|[2][0-9]))\d{7}$/;

export const PERMISSION_TYPES = {
  CON_APP: 'CON_APP',
  CON_IMP: 'CON_IMP',
  PERM: 'PERM',
  TRAN_IMP: 'TRAN_IMP',
  TRAN_APP: 'TRAN_APP',
  SET_USER_EDIT: 'SET_USER_EDIT',
  SET_USER: 'SET_USER',
  SET_USERS_VIEW: 'SET_USERS_VIEW',
  ADD_TRANS: 'ADD_TRANS',
  SET_ROLES_EDIT: 'SET_ROLES_EDIT',
  SET_BRANCH: 'SET_BRANCH',
  SET_BANK: 'SET_BANK',
  SET_PERMISSIONS_EDIT: 'SET_PERMISSIONS_EDIT',
  PAY_ADD: 'PAY_ADD',
  SET_E: 'SET_E',
};
